<template>
  <div class="export-dialog">
    <!-- 匹配订单护照页-->
    <el-dialog :visible.sync="dialogShow" width="1500px" :close-on-click-modal="true" @closed="handleClosed">
      <div class="dialog-member-title">
        <span class="dialog-member-name">批量申请发票</span>
        <div class="dialog-close" @click="closeFn">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div v-loading="loading">
        <div class="dialog-member-content">
          共查询到 {{ dataList.length }} 条数据
        </div>
        <VirtualTable ref="virtualTableRef" :table-data="dataList" :table-height="400" :row-height="48" :row-key="'id'"
          :checkedIds="checkedIds" @selection-change="handleSelectionChange">
          <template slot="columns">
            <el-table-column prop="" label="合作客户" width="140">
              <template slot-scope="scope">
                <div>{{ scope.row.coreCustomerInfo ? scope.row.coreCustomerInfo.companyName : '--' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="商户信息" width="140">
              <template slot-scope="scope">
                <div>{{ scope.row.merchatInfo ? scope.row.merchatInfo.companyName : '--' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="100">
            </el-table-column>
            <el-table-column prop="payableAmount" label="订单金额" min-width="80">
            </el-table-column>
            <el-table-column prop="paidAmount" label="订单实收" min-width="80">
            </el-table-column>
            <el-table-column prop="paidAmount" label="订单未收" min-width="80">
              <template slot-scope="scope">
                <div>{{ scope.row.payableAmount - scope.row.paidAmount }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="paidAmount" label="本次收款" min-width="150">
              <template slot-scope="scope">
                <el-input 
                  type="number" 
                  v-model="scope.row.currentAmount"
                  size="mini"
                  style="width: 100%"
                ></el-input>
              </template>
            </el-table-column> -->
            <el-table-column prop="visaLegend" label="国家-类型" min-width="150">
              <template slot-scope="scope">
                <p>{{ scope.row.countryName }}</p>
                <p>{{ scope.row.visaTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="visaTitle" label="产品名称" min-width="160">
              <template slot-scope="scope">
                <p>{{ scope.row.visaTitle }}</p>
                <div v-if="scope.row.marks">
                  <el-tooltip placement="top" :content="scope.row.marks">
                    <div class="marks-text" style="color: #e41313;">{{ scope.row.marks }} </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="statusName" label="订单状态" width="100">
              <template slot-scope="scope" @click.stop>
                <el-tag :type="setStatus(scope.row.status)" size="small"> {{ scope.row.statusName }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="userName" label="来源" class="kaka" min-width="180">
              <!-- orderSource  0：商户 1：平台 2:用户 3:API接口 -->
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row.appName }}
                    <span v-if="scope.row.appType.indexOf('微信') > -1" class="source-type"
                      style="padding: 2px 4px;background-color: #168743;"> 微 </span>
                    <span v-else-if="scope.row.appType.indexOf('支付宝') > -1" class="source-type"
                      style="padding: 2px 4px;background-color: #0085ff;"> 支</span>
                    <span v-else-if="scope.row.appType" class="source-type"
                      style="padding: 2px 4px;background-color: #ff6c37;"> {{ scope.row.appType }}
                    </span>
                  </div>
                  <div>
                    {{ scope.row.merchatInfo && scope.row.merchatInfo.companyName || '--' }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="contacts" label="联系人信息" min-width="120px">
                            <template slot-scope="scope">
                                <span class="source-type" :style="{
                                    background: setOrderSourceColor(scope.row.orderSource),
                                }">{{ setOrderSourceText(scope.row.orderSource) }}</span>
                                <span>{{ scope.row.contacts ? scope.row.contacts : "--" }}</span><br />
                                <span>{{
                                    scope.row.contactPhone ? scope.row.contactPhone : "--"
                                }}</span>
                                <div v-if="scope.row.wechatName" :title="scope.row.wechatName"
                                    style="transform: scale(0.6);transform-origin: left;white-space: nowrap;">{{
                                        scope.row.wechatName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="serviceMarks" label="操作备注" min-width="100">
                            <template slot-scope="scope">
                                <div>
                                    <div v-if="scope.row.marks">
                                        <el-tooltip placement="top" :content="scope.row.marks">
                                            <div class="marks-text" style="color: #e41313;">{{ scope.row.marks }} </div>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </template>
                        </el-table-column> -->
          </template>
        </VirtualTable>
        <div class="dialog-member-content">
          <el-button type="primary" @click="handleExporetSelect">批量开发票{{ allPrice }}</el-button>
          <el-button @click="closeFn">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="visibleInvoice" width="560px" top="5vh" :close-on-click-modal="false" title="发票处理"
      custom-class="batch-invoice-dialog" @open="resetInvoiceDialog">
      <section class="invoice-summary">
        <div class="invoice-summary-heading">
          <span>关联订单 {{ selectedItems.length }} 笔</span>
          <el-button type="text" @click="invoiceOrdersExpanded = !invoiceOrdersExpanded">{{ invoiceOrdersExpanded ? '隐藏'
            :
            '展开' }}</el-button>
        </div>
        <div class="invoice-summary-total"><span>订单合计</span><strong>{{ formatInvoiceAmount(allPrice) }}</strong></div>
        <div v-show="invoiceOrdersExpanded" class="invoice-orders">
          <div class="invoice-order-row invoice-order-header"><span>订单号</span><span>订单金额</span></div>
          <div class="invoice-order-list">
            <div v-for="item in selectedItems" :key="item.id" class="invoice-order-row">
              <span>{{ item.orderNo }}</span><span>{{ formatInvoiceAmount(item.currentAmount) }}</span>
            </div>
          </div>
        </div>
      </section>
      <el-tabs v-model="invoiceTab" class="invoice-tabs">
        <el-tab-pane label="申请开票" name="apply">
          <el-form :model="addReceiveForm" :rules="addReceiveFormRules" ref="addReceiveFormRef" label-position="top">
            <el-form-item label="开票信息" prop="invoiceInfo">
              <el-input type="textarea" :rows="7" v-model="addReceiveForm.invoiceInfo"
                :placeholder="invoicePlaceholder"></el-input>
              <div class="invoice-form-hint">可直接粘贴整段信息，无需逐项填写。</div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="上传发票" name="upload">
          <div class="invoice-upload-label">发票文件</div>
          <upload class="invoice-upload-area" :class="{ 'invoice-upload-empty': !invoiceUploadUrl }"
            v-model="invoiceUploadUrl" :image-url="invoiceUploadUrl" :auto-upload="true" :drag="true" thisType="custom"
            @uploading="invoiceUploading = !$event" />
          <div class="invoice-form-hint">上传的发票将关联至以上所选订单。</div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="invoice-footer">
        <el-button :disabled="invoiceSubmitting" @click="visibleInvoice = false">取消</el-button>
        <el-button type="primary" :loading="invoiceSubmitting" :disabled="invoiceUploading"
          @click="submitInvoiceDialog">
          {{ invoiceTab === 'apply' ? '提交申请' : '确认上传' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { batchimportapplicant } from "@/api/order";
import { queryorderorg } from "@/api/orderCenter";
import { export_json_to_excel } from '@/utils/Export2Excel';
import VirtualTable from "./VirtualTable.vue";
import { addretransactionrecord, getQueryaccount, batchaddretransactionrecord, querycorecustomers } from '@/api/finance';
import upload from '@/components/upload.vue';
import time1 from "@/assets/images/order/time1.png";
import { orderinvoice, orderuploadinvoice } from "@/api/order";
export default {
  name: "orderDownloadDialog",
  computed: {
    allPrice() {
      if (this.selectedItems.length == 0) {
        return 0
      }
      let num = 0
      console.log(this.selectedItems);

      this.selectedItems.forEach(item => {
        num += Number(item.currentAmount) ? Number(item.currentAmount) : 0
      })
      return num.toFixed(2).replace(/\.?0+$/, '')
    },
    price() {
      return (item) => {
        let priceNum = item.paidAmount - item.refundAmount;
        // 保留两位小数并且小数点后无零则不显示小数点
        if ((item.payableAmount - item.paidAmount) > 0) {
          return `${item.payableAmount}/${item.paidAmount}`
        }
        return priceNum.toFixed(2).replace(/\.?0+$/, '');
      }
    },
    formatTime2() {
      return (value) => {
        return this.$moment(value).format("YY-MM-DD");
      };
    },
    formatTime() {
      return (value) => {
        return this.$moment(value).format("YY-MM-DD HH:mm");
      };
    },
    setStatus() {
      return function (status) {
        if (status == -4 || status == -2 || status == -3 || status == 2 || status == -1) {
          return "danger";
        } else if ([6, 7, 8].indexOf(status) > -1) {
          return "success";
        } else {
          return "warning";
        }
      };
    },
    setOrderSourceText() {
      return function (num) {
        let str = "";
        switch (num) {
          case 0:
            str = "商";
            break;
          case 1:
            str = "平";
            break;
          case 2:
            str = "用";
            break;
          default:
            str = "接";
        }
        return str;
      };
    },
    setOrderSourceColor() {
      return function (num) {
        let str = "";
        switch (num) {
          case 0:
            str = "#4791EA";
            break;
          case 1:
            str = "#49BD49";
            break;
          case 2:
            str = "#F79534";
            break;
          default:
            str = "#EA4747";
        }
        return str;
      };
    }
  },
  data() {
    return {
      time1,
      dialogShow: false,
      loading: false,
      dataList: [],
      checkedIds: [],
      virtualTableRef: null,
      visibleAddReceive: false,
      visibleInvoice: false,
      invoiceTab: 'apply',
      invoiceOrdersExpanded: true,
      invoiceSubmitting: false,
      invoiceUploading: false,
      invoiceUploadUrl: '',
      invoicePlaceholder: '请在此粘贴完整的开票信息，例如：\n发票抬头：\n纳税人识别号：\n开户银行及账号：\n注册地址及电话：\n接收邮箱：',
      querycorecustomersList: [],
      addReceiveForm: {
        amount: '',
        accountId: '',
        remark: '',
        imgUrl: '',
        customerId: '',
        invoiceInfo: ""
      },
      addReceiveFormRules: {
        invoiceInfo: [{ required: true, whitespace: true, message: '请输入开票信息', trigger: 'blur' }],
        amount: [
          // { required: true, message: '请输入金额', trigger: 'blur' },
          // { pattern: /^\d+(\.\d+)?$/, message: '请输入有效的数字金额', trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: '请选择账户', trigger: 'change' }
        ],
      },
      accountList: [],
      selectedItems: [],
    };
  },
  components: {
    VirtualTable,
    upload
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formDate: {
      type: Object,
      default: () => ({})
    },
    PlanVisaDateTime: {
      type: Array,
      default: () => ([])
    },
    dateInfo: {
      type: Array,
      default: () => ([])
    },
  },
  watch: {
    visible(val) {
      this.dialogShow = val;
      if (val) {
        console.log('visible', val);
        console.log(this.formDate, this.PlanVisaDateTime, this.dateInfo)
        this.handleGetFailData()
        this.selectedItems = []
      }
    }
  },
  methods: {
    formatInvoiceAmount(value) {
      return '¥' + (Number(value) || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    resetInvoiceDialog() {
      this.invoiceTab = 'apply';
      this.invoiceOrdersExpanded = true;
      this.invoiceUploadUrl = '';
      this.invoiceUploading = false;
      this.$nextTick(() => this.$refs.addReceiveFormRef && this.$refs.addReceiveFormRef.clearValidate());
    },
    async submitInvoiceDialog() {
      if (this.invoiceSubmitting || this.invoiceUploading) return;
      if (this.invoiceTab === 'apply') {
        const valid = await this.$refs.addReceiveFormRef.validate().catch(() => false);
        if (!valid) return;
      } else if (!this.invoiceUploadUrl) {
        this.$message.warning('请上传发票');
        return;
      }
      this.invoiceSubmitting = true;
      try {
        if (this.invoiceTab === 'apply') {
          const res = await orderinvoice({
            orderIds: this.selectedItems.map(item => item.id),
            reMarks: this.addReceiveForm.remark,
            customerId: this.addReceiveForm.customerId,
            invoiceInfo: this.addReceiveForm.invoiceInfo,
          });
          if (res.code != 1) throw new Error(res.msg || '申请失败');
        } else {
          for (const item of this.selectedItems) {
            const res = await orderuploadinvoice({ orderId: item.id, url: this.invoiceUploadUrl, customerId: item.coreCustomerId || '' });
            if (res.code != 1) throw new Error(res.msg || '上传失败');
          }
        }
        this.$message.success('操作成功！');
        this.visibleInvoice = false;
        this.addReceiveForm.invoiceInfo = '';
        this.$emit('refresh');
        this.handleGetFailData();
        this.$refs.virtualTableRef.clearAllSelection();
      } catch (error) {

      } finally {
        this.invoiceSubmitting = false;
      }
    },
    handleCustomerChange(value) {
      const selectedCustomer = this.querycorecustomersList.find(item => item.value === value);
      if (selectedCustomer) {
        this.addReceiveForm.invoiceInfo = selectedCustomer.invoiceInfo || '';
      } else {
        this.addReceiveForm.invoiceInfo = '';
      }
    },
    getQuerycorecustomers() {
      querycorecustomers({
        "Page.Index": 1,
        "Page.Size": 9999,
      }).then(res => {
        this.querycorecustomersList = res.data.rows.map(t => {
          return {
            label: t.companyName,
            value: t.id,
            invoiceInfo: t.invoiceInfo,
          };
        });
      });
    },
    handleSelectionChange(val) {
      this.selectedItems = val
    },
    closeFn() {
      this.$emit('close')
    },
    handleClosed() {
      // 清除数据
      this.dataList = []
      this.checkedIds = []
      this.$emit('close')
    },
    // 获取失败数据
    handleGetFailData() {
      this.loading = true
      let tempData = { ...this.formDate }
      let data = {
        ...tempData,
        "Page.Size": tempData.pageSize,
        "Page.Index": tempData.pageIndex
      }
      if (!this.PlanVisaDateTime) {
        tempData.PlanVisaStartTime = "";
        tempData.PlanVisaEndTime = "";
      } else {
        tempData.PlanVisaStartTime = this.PlanVisaDateTime[0];
        tempData.PlanVisaEndTime = this.PlanVisaDateTime[1];
      }
      if (!this.dateInfo) {
        tempData.StartTime = "";
        tempData.EndTime = "";
      } else {
        tempData.StartTime = this.dateInfo[0];
        tempData.EndTime = this.dateInfo[1];
      }
      queryorderorg(data).then(res => {
        console.log(res)
        if (res.code == 1) {
          this.dataList = res.data.row.map(item => {
            return {
              ...item,
              birthDay: item.birthDay ? this.$moment(item.birthDay).format('YYYY-MM-DD') : '',
              passportValidity: item.passportValidity ? this.$moment(item.passportValidity).format('YYYY-MM-DD') : '',
              passportIssue: item.passportIssue ? this.$moment(item.passportIssue).format('YYYY-MM-DD') : '',
              currentAmount: item.payableAmount,

            }
          })
        }
      }).finally(() => {
        this.loading = false;

      })
    },
    submitSelectionUpload() {
      this.exportMethod(this.dataList)
      this.$message.success(`正在导出 ${this.dataList.length} 条数据`)

    },
    handleExporetSelect() {
      const selection = this.$refs.virtualTableRef.getSelection()
      console.log('选中收款数据:', selection)
      if (selection.length == 0) {
        this.$message.error('请选择要开发票的申请人')
        return
      }
      const customerIds = selection.filter(item => item.coreCustomerId).map(item => item.coreCustomerId)
      this.addReceiveForm.customerId = customerIds.length > 0 ? customerIds[0] : ''
      this.addReceiveForm.invoiceInfo = this.querycorecustomersList.find(item => item.value === this.addReceiveForm.customerId)?.invoiceInfo || ''
      this.selectedItems = selection;
      this.visibleInvoice = true;
    },
    handleAmountInput() {
      this.addReceiveForm.amount = this.addReceiveForm.amount.toString().replace(/[^\d.]/g, '');
      const parts = this.addReceiveForm.amount.split('.');
      if (parts.length > 2) {
        this.addReceiveForm.amount = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts[1] && parts[1].length > 2) {
        this.addReceiveForm.amount = parts[0] + '.' + parts[1].substring(0, 2);
      }
    },
    saveAddReceive() {
      this.$refs.addReceiveFormRef.validate(valid => {
        if (valid) {
          const submitData = {
            orderIds: this.selectedItems.map(t => t.id),
            reMarks: this.addReceiveForm.remark,
            customerId: this.addReceiveForm.customerId,
            invoiceInfo: this.addReceiveForm.invoiceInfo,
          }
          orderinvoice(submitData).then(res => {
            if (res.code == 1) {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$emit('refresh');
              this.handleGetFailData()
              this.$refs.virtualTableRef.clearAllSelection()
            } else {
            }
          });
          // addretransactionrecord(submitData).then(res => {
          //   if (res.code == 1) {
          //     this.$message({
          //       message: "操作成功！",
          //       type: "success",
          //     });
          //     this.$emit('refresh');
          //     this.handleGetFailData()
          //   } else {
          //     this.$message({
          //       message: res.msg,
          //       type: "warning",
          //     });
          //   }
          // });

          this.visibleInvoice = false;
          this.addReceiveForm = {
            amount: '',
            accountId: '',
            remark: '',
            imgUrl: '',
            customerId: '',
            invoiceInfo: '',
          };
        } else {
          return false;
        }
      });
    },
    exportMethod(exportData) {
      const tHeader = ['申请人姓名', '护照号', '性别', '出生日期', '护照生效日期', '护照有效期', '申请人状态', '申请编号', '订单操作备注', '失败原因'] // 表格头部
      const filename = '申请人信息表'
      let data = exportData.map(item => {
        return [
          item.applicantName,
          item.passportNumber,
          item.genderName,
          item.birthDay,
          item.passportIssue,
          item.passportValidity,
          item.statusName,
          item.applyNumber,
          item.serviceMarks,
          item.latestStatus,
        ]
      })
      console.log(data);
      console.log(filename);
      console.log(tHeader);



      export_json_to_excel({
        header: tHeader,
        data,
        filename
      })
    },
    getAccountList() {
      getQueryaccount({
        "Page.Index": 1,
        "Page.Size": 9999,
      }).then(res => {
        this.accountList = res.data.rows.map(t => {
          return {
            label: t.accountName,
            value: t.id,
          };
        });
      });
    },
  },
  created() {
    this.getAccountList();
    this.getQuerycorecustomers()
  },
};
</script>

<style lang="scss">
.export-dialog {

  .el-dialog {
    background-color: transparent;

    .el-dialog__header {
      display: none !important;
    }

    .el-dialog__body {
      background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
      border-radius: 12px;
      box-sizing: border-box;
      overflow: hidden;
    }
  }

  .dialog-member-content {
    padding: 10px;
  }
}
</style>
<style lang="scss">
.export-dialog .el-dialog.batch-invoice-dialog {
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 6px;
  overflow: hidden;

  .el-dialog__header {
    display: block !important;
    padding: 24px 24px 20px;
  }

  .el-dialog__title {
    font-size: 18px;
    color: #152238;
  }

  .el-dialog__headerbtn {
    top: 28px;
    right: 24px;
  }

  .el-dialog__body {
    padding: 0 24px 32px;
    background: #fff;
    border-radius: 0;
    color: #152238;
  }

  .invoice-summary {
    padding: 12px 16px 16px;
    background: #f5f7fa;
    border-radius: 4px;
  }

  .invoice-summary-heading,
  .invoice-summary-total,
  .invoice-order-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .invoice-summary-heading {
    min-height: 32px;

    .el-button {
      padding: 0;
    }
  }

  .invoice-summary-total {
    padding: 12px 0 16px;
    color: #909399;

    strong {
      font-weight: 400;
      color: #152238;
    }
  }

  .invoice-order-row {
    min-height: 40px;
    border-top: 1px solid #e1e5ed;
    font-size: 16px;

    span:last-child {
      white-space: nowrap;
    }
  }

  .invoice-order-header {
    font-size: 13px;
    color: #909399;
  }

  .invoice-order-list {
    max-height: 200px;
    overflow-y: auto;
  }

  .invoice-tabs {
    margin-top: 12px;
    min-height: 340px;
  }

  .el-tabs__header {
    margin-bottom: 24px;
  }

  .el-tabs__nav-wrap::after {
    height: 1px;
    background: #dfe4ed;
  }

  .el-tabs__item {
    font-weight: 400;
  }

  .el-form-item__label {
    padding-bottom: 8px;
    line-height: 24px;
    color: #303133;
  }

  .el-textarea__inner {
    padding: 12px;
    line-height: 25px;
    min-height: 192px !important;
  }

  .invoice-form-hint {
    margin-top: 6px;
    font-size: 12px;
    line-height: 20px;
    color: #909399;
  }

  .invoice-upload-area {
    display: block;
    width: 100%;
    background: transparent;
    border-radius: 6px;

    .avatar-uploader,
    .el-upload {
      display: block;
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
      background: transparent;
      line-height: 0;
      vertical-align: top;
    }

    .el-upload-dragger {
      display: block;
      position: relative;
      width: 100%;
      height: 160px;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      overflow: hidden;
      border-radius: 6px;
      background: #f2f8ff;
      line-height: 22px;
    }

    &.invoice-upload-empty {

      .avatar,
      .btn-show,
      .del-show {
        display: none;
      }
    }

    .el-upload__text {
      height: 100%;
      padding: 28px 24px;
      box-sizing: border-box;
      justify-content: center;
    }

    .avatar {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      margin: 0;
    }

    .avatar .el-image__inner {
      object-fit: contain !important;
    }

    .el-upload-img {
      margin-top: 0;
    }

    .el-upload-span {
      margin-top: 16px;
      line-height: 22px;
    }

    +.invoice-form-hint {
      margin-top: 10px;
    }
  }

  .invoice-upload-label {
    margin-bottom: 12px;
  }

  .el-dialog__footer {
    border-top: 1px solid #ebeef5;
    padding: 16px 24px;
  }

  .invoice-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .el-button {
      margin-left: 0;
      min-height: 44px;
      padding: 12px 20px;
    }
  }
}
</style>
